import constants from "../constants";
import imageService from "../service/imageService";
import { updatePageBars } from "./selection";
import util from "../util";
import store from "../store";

export function handlePixabayUpload($comp, pixabayInfo, newSrc, isAddComponent) {
    let pixabayId = pixabayInfo.id;
    let ext = newSrc.split('.').pop();
    let url = `${constants.SECURE_S3_PATH}public/pixabay-images/${pixabayId}.${ext}`;
    let uploadedPreviewURL = `${constants.SECURE_S3_PATH}public/pixabay-images/previews/${pixabayId}.${ext}`;

    let oldSrc = $comp.attr('data-original-bg-img');

    let image = new Image();
    image.onload = function () {
        if (this.width > 0) {
            $comp.find('.img').css('background-image', `url("${url}")`);
            $comp.find('.img').attr('aria-label', pixabayInfo.tags ? pixabayInfo.tags : '');
            if (isAddComponent) {
                $comp.attr('data-path-original', url);
                $comp.find('.img').attr('data-original-bg-img', url);
                util.nextTick(() => { updatePageBars($comp); });
            } else {
                $comp.attr('data-path-original', oldSrc);
                $comp.find('.img').attr('data-original-bg-img', oldSrc);
            }

            let previewImage = new Image();
            previewImage.onerror = function () {
                imageService.uploadPixabayImage(newSrc, pixabayInfo.previewURL, pixabayId);
            }
            previewImage.src = uploadedPreviewURL;
        }
    }
    image.onerror = function () {
        imageService.uploadPixabayImage(newSrc, pixabayInfo.previewURL, pixabayId).then(resp => {
            let uploadedUrl = constants.SECURE_S3_PATH + resp.data;
            $comp.find('.img').css('background-image', `url("${uploadedUrl}")`);

            if (isAddComponent) {
                $comp.attr('data-path-original', uploadedUrl);
                $comp.find('.img').attr('data-original-bg-img', uploadedUrl);
                util.nextTick(() => { updatePageBars($comp); });
            } else {
                $comp.attr('data-path-original', oldSrc);
                $comp.find('.img').attr('data-original-bg-img', oldSrc);
            }
        });
    }
    image.src = url;
    imageService.pushMemberRecentImage(store.getState().memberId, pixabayId, url, uploadedPreviewURL, pixabayInfo.user, pixabayInfo.pageURL);
}

export function handlePixabayVideoUpload($comp, pixabayInfo, newSrc, isAddComponent) {
    let pixabayId = pixabayInfo.id;
    let ext = newSrc.split('.').pop().split('?').shift();
    let url = `${constants.SECURE_S3_PATH}public/pixabay-videos/${pixabayId}.${ext}`;
    let uploadedPreviewURL = `${constants.SECURE_S3_PATH}public/pixabay-videos/previews/${pixabayId}.${ext}`;

    let oldSrc = $comp.find('.video').attr('data-original-bg-video');

    let video = $comp.find('.video').find('video').get(0);
    video.onloadeddata = function () {
        if (this.videoWidth > 0) {
            if (isAddComponent) {
                $comp.attr('data-path-original', url);
                $comp.find('.video').attr('data-original-bg-video', url);
                // util.nextTick(() => { updatePageBars($comp); });
            } else {
                $comp.attr('data-path-original', oldSrc);
                $comp.find('.video').attr('data-original-bg-video', oldSrc);
            }

            // let previewImage = new Image();
            // previewImage.onerror = function() {
            // imageService.uploadPixabayImage(newSrc, pixabayInfo.previewURL, pixabayId);
            // }
            // previewImage.src = uploadedPreviewURL;
        }
    }
    video.onerror = function () {
        imageService.uploadPixabayImage(newSrc, pixabayInfo.previewURL, pixabayId).then(resp => {
            let uploadedUrl = constants.SECURE_S3_PATH + resp.data;

            if (resp.data) {
                video.src = uploadedUrl;

                if (isAddComponent) {
                    $comp.attr('data-path-original', uploadedUrl);
                    $comp.find('.video').attr('data-original-bg-video', uploadedUrl);
                    // util.nextTick(() => { updatePageBars($comp); });
                } else {
                    $comp.attr('data-path-original', oldSrc);
                    $comp.find('.video').attr('data-original-bg-video', oldSrc);
                }
            } else {
                video.src = oldSrc;
            }
        });
    }
    video.src = url;
}